import { SpringAPI } from 'defs/http/api';
import axios, { AxiosResponse } from 'helper/axios-facade';
import { TutorialIdType } from 'types/Tutorial';

export type ResponseGetTutorialsType = {
	profileId: number;
	tutorialNames: Array<TutorialIdType>;
};
export type ResponseResolveTutorialsType = {};

export type GetTutorialsSettingsType = {};
export type ResolveTutorialsSettingsType = { flag: TutorialIdType };

export const getTutorials = (settings: GetTutorialsSettingsType): Promise<AxiosResponse<ResponseGetTutorialsType>> => {
	const requestUrl = SpringAPI.tutorial.loadTutorials();
	return axios.get(requestUrl, settings);
};
export const resolveTutorial = (
	settings: ResolveTutorialsSettingsType
): Promise<AxiosResponse<ResponseResolveTutorialsType>> => {
	const requestUrl = SpringAPI.tutorial.updateTutorial({
		flag: settings.flag,
	});
	return axios.post(requestUrl, settings);
};
